// src/models/price-ranges.model.ts
import { z } from "zod";
var PRICE_RANGE_OPTIONS = [
  { id: "below-5", min: 0, max: 5 },
  { id: "5-7", min: 5, max: 7 },
  { id: "7-10", min: 7, max: 10 },
  { id: "10-12", min: 10, max: 12 },
  { id: "more-than-12", min: 12, max: void 0 }
];
var priceRangeIdSchema = z.enum(
  PRICE_RANGE_OPTIONS.map((o) => o.id)
);

// src/models/storage.buckets.model.ts
var ALLOWED_BUCKETS = {
  USER_IDS: "USER_IDS",
  TEMPORARY_PRESCRIPTIONS: "TEMPORARY_PRESCRIPTIONS",
  PRESCRIPTIONS: "PRESCRIPTIONS",
  PRODUCT_IMAGES: "PRODUCT_IMAGES",
  VENDOR_LOGOS: "VENDOR_LOGOS"
};

export {
  PRICE_RANGE_OPTIONS,
  priceRangeIdSchema,
  ALLOWED_BUCKETS
};
//# sourceMappingURL=chunk-TBUW4BYS.js.map